module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message message-success",
    class: _vm.toggleClass
  }, [_c('div', {
    staticClass: "message-title"
  }, [_c('div', {
    staticClass: "message-msg"
  }, [(_vm.type === 'success') ? _c('img', {
    attrs: {
      "src": require("../../../assets/profile/icon_succeed.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'error') ? _c('img', {
    attrs: {
      "src": require("../../../assets/profile/icon_error.png")
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default", [(_vm.msg.length > 0) ? _c('p', [_vm._v(_vm._s(_vm.msg))]) : _vm._e()])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcf144a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/Common/Message.vue
// module id = 865
// module chunks = 0